module.exports = __webpack_public_path__ + "img/zip-lines--icon--gray.dfc59d88.svg";